if (!customElements.get('testimonials-component')) {
    class Testimonials extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.selectors = {
                sliderWrapper: '.testimonials__items',
                pagination: '.swiper-pagination',
                nextEl: '.swiper-btn-next',
                prevEl: '.swiper-btn-prev',
            };
            this.classes = {
                grid: 'f-grid',
                swiper: 'swiper',
                swiperWrapper: 'swiper-wrapper',
            };

            this.sectionId = this.dataset.sectionId;
            this.section = this.closest(`.section-${this.sectionId}`);
            this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);

            this.enableSlider = this.dataset.enableSlider === 'true';
            this.items = parseInt(this.dataset.items);
            this.tabletItems = parseInt(this.dataset.tabletItems);

            this.sliderInstance = false;

            if (!this.enableSlider) return;

            this.init();
        }

        init() {
            this.initSlider();
        }

        initSlider() {
            const sliderOptions = {
                navigation: {
                    nextEl: this.section.querySelector(this.selectors.nextEl),
                    prevEl: this.section.querySelector(this.selectors.prevEl),
                },
                pagination: false,
                loop: false,
                threshold: 2,
                breakpoints: {
                    1440: {
                        slidesOffsetAfter: 136,
                    },
                },
                slidesPerView: this.items <= 3 ? this.items : 'auto',
            };

            if (typeof this.sliderInstance !== 'object') {
                this.classList.add(this.classes.swiper);
                this.sliderWrapper.classList.remove(this.classes.grid);
                this.sliderWrapper.classList.add(this.classes.swiperWrapper);
                this.sliderInstance = new Swiper(this, sliderOptions);
                this.sliderInstance.init();
            }
        }

        destroySlider() {
            this.classList.remove(this.classes.swiper);
            this.sliderWrapper.classList.remove(this.classes.swiperWrapper);
            this.sliderWrapper.classList.add(this.classes.grid);
        }
    }
    customElements.define('testimonials-component', Testimonials);
}
